export default "__VITE_ASSET__CydOTzgY__"